import React, { memo } from 'react';

var AboutHashComponent = function (_a) {
    var scrollRef = _a.scrollRef, aboutHashInnerContent = _a.aboutHashInnerContent;
    return (React.createElement("div", { className: 'pr-f-text-wrp', ref: scrollRef }, aboutHashInnerContent));
};
AboutHashComponent.displayName = 'AboutHash';
var AboutHash = memo(AboutHashComponent);

export { AboutHash };
